<template>
    <div class="h-full w-full flex lg:items-center justify-center">
        <div
            ref="panzoomElement"
            :class="`grid-cols-${numberOfColumns}`"
            class="w-full h-fit lg:h-full px-10 xl:px-14 grid grid-rows-1 auto-rows-auto gap-10 xl:gap-14"
        >
            <div v-for="colNumber in numberOfColumns" class="flex flex-col gap-10 xl:gap-14 justify-center odd:pb-10 even:pt-10">
                <OrganismImageHover v-for="event in filteredEvents.slice(numberOfRows*(colNumber-1), (numberOfRows*(colNumber-1))+numberOfRows)" :key="`event-${event.id}`" :event="event" />
            </div>
        </div>
    </div>
</template>

<script>
import OrganismImageHover from "../components/anarchive/organisms/OrganismImageHover.vue";
import {random} from "lodash";
import Panzoom from "@panzoom/panzoom";
import ScreenSize from "../mixins/screen-size";
import AtomIconButton from "../components/global/atoms/AtomIconButton.vue";
import LayoutAnarchive from "../layouts/LayoutAnarchive.vue";
import {mapGetters} from "vuex";

export default {
    name: "PageAnarchiveGrid",
    components: {LayoutAnarchive, AtomIconButton, OrganismImageHover},
    mixins: [ScreenSize],
    data() {
        return {
            panzoom: null,
            wheelEventListener: null,
        }
    },
    mounted() {
        this.initPanzoom();
    },
    beforeDestroy() {
        this.wheelEventListener = null;
    },
    computed: {
        ...mapGetters('event', {
            events: 'getFilteredAnarchiveEvents',
        }),
        numberOfColumns() {
            if (this.isMobile) {
                return 2;
            }

            if (this.isTablet) {
                return 5;
            }

            return 10;
        },
        filteredEvents() {
            const randomEvents = this.events.slice().sort(() => 0.5 - Math.random());
            return randomEvents.slice(0, 40);
        },
        numberOfRows() {
            return this.filteredEvents.length / this.numberOfColumns;
        },
        panzoomConfig() {
            if (this.isMobile) {
                return {
                    startScale: 1.5,
                    maxScale: 2.5,
                    minScale: 1,
                    contain: 'outside',
                }
            }

            if (this.isTablet) {
                return {
                    startScale: 2,
                    maxScale: 3,
                    minScale: 1,
                    contain: 'outside',
                }
            }

            return {
                startScale: 2,
                maxScale: 3.5,
                minScale: 1,
                contain: 'outside',
            }
        }
    },
    methods:{
        random,
        initPanzoom() {
            const element = this.$refs.panzoomElement;

            const panzoom = Panzoom(element, this.panzoomConfig)

            this.wheelEventListener = element.parentElement.addEventListener('wheel', panzoom.zoomWithWheel);

            this.panzoom = panzoom;
        },
        handlePlus(){
            this.panzoom.zoomIn()
        },
        handleMinus() {
            this.panzoom.zoomOut()
        }
    }
}
</script>

<style scoped>

</style>
